
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"21","height":"21"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 6560"}},[_c('g',{attrs:{"data-name":"Group 222","transform":"translate(2.121 1.5)","fill":"none","stroke":"#6d66a2","stroke-miterlimit":"10","stroke-width":"3"}},[_c('circle',{attrs:{"data-name":"Ellipse 22","cx":"7.337","cy":"7.337","r":"7.337","transform":"translate(2.647)"}}),_c('path',{attrs:{"data-name":"Line 26","stroke-linecap":"round","d":"M0 17.326l4.797-4.797"}})])])])
          )
        }
      }
    